/**
 * 메뉴 표시 컴포넌트
 */

import React from "react";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import {Grid, Pagination, PaginationItem, Stack, Typography} from "@mui/material";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { gridPageCountSelector, gridPageSelector, useGridApiContext, useGridSelector } from "@mui/x-data-grid";

const UPagination = (props) => {
  const apiRef = useGridApiContext();
  const page = useGridSelector(apiRef, gridPageSelector);
  const pageCount = useGridSelector(apiRef, gridPageCountSelector);

  const onhandleChange = (value) => {
    apiRef.current.setPage(value - 1);
    props.onPageChange(value);
  }  
  
  return (
    <Grid container direction="row" justifyContent="center" alignItems="center">
      <Pagination
        color="primary"
        variant="outlined"
        shape="rounded"
        page={page + 1}
        count={pageCount}
        showFirstButton
        showLastButton
        size="large"
        renderItem={(props2) => <PaginationItem {...props2} disableRipple />}
        //onChange={(event, value) => apiRef.current.setPage(value - 1)}
        onChange={(event,value)=>onhandleChange(value)}
      />
    </Grid>
  );
};

export default UPagination;
